import axios from 'axios';
import store from '@/store';
import serializer from '@/utils/serializer';
import { router } from '@/router';

const baseDomain = process.env.VUE_APP_DOMAIN;
const baseUrl = `${baseDomain}`;

const access_token = localStorage.getItem('authenticated')
  ? JSON.parse(localStorage.getItem('authenticated')).access_token
  : '';

const api = axios.create({
  baseURL: baseUrl
});

api.interceptors.request.use(function(request) {
  if (localStorage.getItem('authenticated')) {
    const token = JSON.parse(localStorage.getItem('authenticated'))
      .access_token;
    request.headers.Authorization = `Bearer ${token}`;
  }

  return request;
});

api.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;

//intercept all requests to check for any errors
api.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response.status === 403) {
      window.location = '/forbidden';
    }

    // TODO: create an error text according to the status returned
    store.dispatch('toasts/_addToast', {
      variant: 'danger',
      text: `${error.response.status}`
    });

    return Promise.reject(error);
  }
);

api.create = function(url, model, data) {
  return new Promise(resolve => {
    serializer.serialize(model, data).then(result => {
      api.post(url, result).then(response => resolve(response));
    });
  });
};

api.update = function(model, data) {
  return new Promise(resolve => {
    serializer.serialize(model, data).then(result => {
      api.put(data.updateUrl, result).then(() => resolve());
    });
  });
};

api.remove = function(model, data) {
  return new Promise(resolve => {
    api.delete(data.deleteUrl).then(() => resolve());
  });
};

api.resend = function(model, data) {
  return new Promise(resolve => {
    api.post(data.resendUrl).then(() => resolve());
  });
};

api.like = function(model, data) {
  return new Promise(resolve => {
    api.post(data.likeUrl).then(() => resolve());
  });
};

api.unlike = function(model, data) {
  return new Promise(resolve => {
    api.post(data.unlikeUrl).then(() => resolve());
  });
};

api.pin = function(model, data) {
  return new Promise(resolve => {
    api.post(data.pinUrl).then(() => resolve());
  });
};

api.unpin = function(model, data) {
  return new Promise(resolve => {
    api.post(data.unpinUrl).then(() => resolve());
  });
};

export default api;
